<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title inline">My Profile</h3>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Name</label>
              <input
                type="text"
                class="form-control"
                v-model="form.name"
                required
              />
            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="form-group">
              <label class="form-label">Email</label>
              <input
                type="email"
                disabled
                class="form-control"
                v-model="form.email"
              />
            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="form-group">
              <label class="form-label">Mobile</label>
              <input type="text" class="form-control" v-model="form.mobile" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Title</label>
              <input type="text" class="form-control" v-model="form.title" />
            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="form-group">
              <label class="form-label">ALN</label>
              <input type="text" class="form-control" v-model="form.aln" />
            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="form-group">
              <label class="form-label">MSISV</label>
              <input type="text" class="form-control" v-model="form.msisv" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Code</label>
              <input type="text" class="form-control" v-model="form.code" />
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer text-right">
        <button type="submit" class="btn btn-primary">Update Profile</button>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        mobile: "",
        title: "",
        aln: "",
        msisv: "",
        code: "",
      },
    };
  },
  methods: {
    onSubmit() {
      //this.$parent.$refs.progressModal.show();
      this.$http.post(this.rootUrl + "user/update-profile", this.form).then(
        (res) => {
          this.refreshToken(res);
          //this.$parent.$refs.progressModal.hide();
          this.$router.push("/");
        },
        (err) => {
          //this.$parent.$refs.progressModal.hide();
          this.$snotify.error(err.response.data.message, "Valuation", {
            timeout: 4000,
            showProgressBar: false,
            position: "rightTop",
          });
        }
      );
    },
    loadData() {
      //this.$parent.$refs.progressModal.show();
      this.$http.get(this.rootUrl + "user/profile", this.corsConfig).then(
        (res) => {
          this.refreshToken(res);
          this.form = res.data;
          //this.$parent.$refs.progressModal.hide();
        },
        (err) => {
          //this.$parent.$refs.progressModal.hide();
          this.$snotify.error(err.response.data.message, "Valuation", {
            timeout: 4000,
            showProgressBar: false,
            position: "rightTop",
          });
        }
      );
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>